/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import TagManager from 'react-gtm-module';

function CommodityService() {
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	return (
		<div className="content_inpage">
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/container/commodity">商品專區</a></li>
				</ul>
				<div className="tab_con">
					<div className="tab_box active">
						<h2 className="tit_main">商品專區-服務內容</h2>
						<div className="content_box service_box">
							<div className="tab">
								<div className="tab_sec">
									<div className="tab_a select"><a href="#">i寶貝智慧聲控服務</a></div>
								</div>
							</div>
							<div style={{ color: "#e61616" }}>●原價99元月租費，依申請相關方案提供方案優惠</div><br />
							<div className="tab_con tab_con_sec">
								<div className="tab_box active">
									<div className="table_box show_web">
										<table border="0" cellPadding="0" cellSpacing="0">
											<tbody>
												<tr>
													<th width="33%">服務品牌</th>
													<th width="33%">範例問句</th>
												</tr>
												<tr>
													<td><div className="brand cb_40">聲控兌品</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，召喚兌品小幫手</span></p></li>
																<li><p className="flex_set"><span>i寶貝，召喚商品兌換小幫手</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_34">SoundOn Podcast</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要聽Podcast</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽「報導者」Podcast</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_41">本月新星</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，召喚本月新星</span></p></li>
																<li><p className="flex_set"><span>i寶貝，最近有什麼新功能?</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_23">KKBOX</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我想聽流行音樂</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽西洋排行榜</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_19">MOD</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要看公視</span></p></li>
																<li><p className="flex_set"><span>i寶貝，「MOD」大聲一點</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_36">個人化助理</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，提醒我明天早上10點拿乾洗衣物</span></p></li>
																<li><p className="flex_set"><span>i寶貝，今天我有哪些待辦事項</span></p></li>
																<li><p className="flex_set"><span>i寶貝，幫我設定明天早上7點的鬧鐘</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我明天有哪些鬧鐘</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_37">整點報時</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>提供整點報時資訊(於指定時間播放「現在時間X點整」)</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_25">童書夢工廠</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我想聽故事</span></p></li>
																<li><p className="flex_set"><span>i寶貝，聽個小紅帽的故事</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_24">中英文兒歌</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要聽兒歌</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽兒歌</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												{/*<tr>
													<td><div className="brand cb_27">愛播聽書FM</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我想聽村上春樹短篇集亮軒書場</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽村上春樹短篇集亮軒書場的第一集</span></p></li>
															</ul>
														</div>
													</td>
												</tr>*/}
												{/*<tr>
													<td><div className="brand cb_45">Live互動英語</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我想聽Live互動英語</span></p></li>
																<li><p className="flex_set"><span>i寶貝，幫我播放Live英語</span></p></li>
															</ul>
														</div>
													</td>
												</tr>*/}
												<tr>
													<td><div className="brand cb_26">大家說英語</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要聽英文</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽大家說英語</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_35">i聽聽精選Podcast</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，播放i聽聽比利大視野</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽i聽聽Podcast</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_21">聲控智慧家電</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，打開冷氣(支援台語)</span></p></li>
																<li><p className="flex_set"><span>i寶貝，關閉冷氣(支援台語)</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_33">台語字典</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，長頸鹿台語怎麼說</span></p></li>
																<li><p className="flex_set"><span>i寶貝，冷氣的台語</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_03">我要說悄悄話</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要說悄悄話。</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要錄音。</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_08">天氣小幫手</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，明天台北天氣如何</span></p></li>
																<li><p className="flex_set"><span>i寶貝，淡水今天要擦防曬乳嗎</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_09">時間小幫手</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，紐約和台北時差幾小時</span></p></li>
																<li><p className="flex_set"><span>i寶貝，多倫多現在幾點 </span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_10">算數小幫手</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，1+2x3等於多少</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_11">說笑話達人</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要聽笑話</span></p></li>
																<li><p className="flex_set"><span>i寶貝，說個笑話來聽聽</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_12">1288</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，幫我找101附近的餐廳</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_13">維基百科</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，周杰倫是誰</span></p></li>
																<li><p className="flex_set"><span>i寶貝，原子彈是什麼</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_14">三竹股市</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，中華電信股票多少</span></p></li>
																<li><p className="flex_set"><span>i寶貝，2412現在漲還是跌</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_15">匯率查詢</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>寶貝，美金現在匯率多少</span></p></li>
																<li><p className="flex_set"><span>i寶貝，1日幣可以換多少台幣</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_17">HiNet生活誌</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要聽國際新聞</span></p></li>
																<li><p className="flex_set"><span>i寶貝，我要聽體育新聞</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_18">查高鐵</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，我要查高鐵</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_28">PickMeUp接送助手(企業應用)</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>提供家長資訊推播(燈燈燈、大樹班、王小明)</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td><div className="brand cb_22">i寶車(需另購千里馬代步車)</div></td>
													<td>
														<div className="cb_dialog">
															<ul>
																<li><p className="flex_set"><span>i寶貝，爸爸的車在哪裡</span></p></li>
																<li><p className="flex_set"><span>i寶貝，爸爸的車電量剩多少</span></p></li>
															</ul>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="list_box show_mobile">
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_34">SoundOn Podcast</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要聽Podcast</span></p></li>
														<li><p><span>i寶貝，我要聽「報導者」Podcast</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_23">KKBOX</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我想聽流行音樂</span></p></li>
														<li><p><span>i寶貝，我要聽西洋排行榜</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_19">MOD</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要看公視</span></p></li>
														<li><p><span>i寶貝，「MOD」大聲一點</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_36">個人化助理</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，提醒我明天早上10點拿乾洗衣物</span></p></li>
														<li><p><span>i寶貝，今天我有哪些待辦事項</span></p></li>
														<li><p><span>i寶貝，幫我設定明天早上7點的鬧鐘</span></p></li>
														<li><p><span>i寶貝，我明天有哪些鬧鐘</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_37">整點報時</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>提供整點報時資訊(於指定時間播放「現在時間X點整」)</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_25">童書夢工廠</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我想聽故事</span></p></li>
														<li><p><span>i寶貝，聽個小紅帽的故事</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_24">中英文兒歌</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要聽兒歌</span></p></li>
														<li><p><span>i寶貝，我要聽月亮出來了</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										{/*<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_27">愛播聽書FM</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我想聽村上春樹短篇集亮軒書場</span></p></li>
														<li><p><span>i寶貝，我要聽村上春樹短篇集亮軒書場的第一集</span></p></li>
													</ul>
												</div>
											</div>
										</div>*/}
										{/*<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_45">Live互動英語</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我想聽Live互動英語</span></p></li>
														<li><p><span>i寶貝，幫我播放Live英語</span></p></li>
													</ul>
												</div>
											</div>
											</div>*/}
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_26">大家說英語</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要聽英文</span></p></li>
														<li><p><span>i寶貝，我要聽大家說英語</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_35">i聽聽精選Podcast</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，播放i聽聽比利大視野</span></p></li>
														<li><p><span>i寶貝，我要聽i聽聽Podcast</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_21">聲控智慧家電</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，打開冷氣(支援台語)</span></p></li>
														<li><p><span>i寶貝，關閉冷氣(支援台語)</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_33">台語字典</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，長頸鹿台語怎麼說</span></p></li>
														<li><p><span>i寶貝，冷氣的台語</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_03">我要說悄悄話</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要說悄悄話。</span></p></li>
														<li><p><span>i寶貝，我要錄音。</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_08">天氣小幫手</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，明天台北天氣如何</span></p></li>
														<li><p><span>i寶貝，淡水今天要擦防曬乳嗎</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_09">時間小幫手</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，紐約和台北時差幾小時</span></p></li>
														<li><p><span>i寶貝，多倫多現在幾點</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_10">算數小幫手</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，1+2x3等於多少</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_11">說笑話達人</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要聽笑話</span></p></li>
														<li><p><span>i寶貝，說個笑話來聽聽</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_12">1288</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，幫我找101附近的餐廳</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_13">維基百科</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，周杰倫是誰</span></p></li>
														<li><p><span>i寶貝，原子彈是什麼</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_14">三竹股市</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，中華電信股票多少</span></p></li>
														<li><p><span>i寶貝，2412現在漲還是跌</span></p></li>
														<li><p><span>i寶貝，大盤今天成交價</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_15">匯率查詢</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，美金現在匯率多少</span></p></li>
														<li><p><span>i寶貝，1日幣可以換多少台幣</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_16">HiChannel廣播</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我想聽中廣流行網</span></p></li>
														<li><p><span>i寶貝，播放警廣</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_17">HiNet生活誌</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要聽國際新聞</span></p></li>
														<li><p><span>i寶貝，我要聽體育新聞</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_18">查高鐵</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，我要查高鐵</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_28">PickMeUp接送助手(企業應用)</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>提供家長資訊推播(燈燈燈、大樹班、王小明)</span></p></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="lb_cell">
											<div className="caption_txt">
												<div className="cb_type">
													<div className="brand cb_22">i寶車(需另購千里馬代步車)</div>
												</div>
												<div className="cb_dialog">
													<ul>
														<li><p><span>i寶貝，爸爸的車在哪裡</span></p></li>
														<li><p><span>i寶貝，爸爸的車電量剩多少</span></p></li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CommodityService;